class AlertService {
  private readonly type: string;
  private readonly message: string;

  constructor(type: string, message: string) {
    this.type = type;
    this.message = message;
  }

  static createSuccessMessage = (message: string) => new AlertService(' alert alert-success', message)
  static createErrorMessage = (message: string) => new AlertService(' alert alert-danger', message)
  static createWarningMessage = (message: string) => new AlertService(' alert alert-warning', message)

  getInitialValues = () => {
    return {type: this.type, message: this.message}
  }

}
export default AlertService
